<template>
  <div class="">
    <b-button variant="secondary" @click="submit" pill :disabled="exporting">
      <b-spinner v-if="exporting" small class="ml-1"></b-spinner>
      <b-icon v-else icon="download" class="ml-1"></b-icon>
      Excel خروجی
    </b-button>
  </div>
</template>

<script>
import {queryBuilder} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/QueryFilter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {getAxiosInstance} from "@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance.js";
import * as XLSX from "xlsx";
import {buildProductWorkbook} from "../DataImport/productExcel";

export default {
  name: "DataExport",
  props: {
    dataType: {
      default: 'product', // for now support: product and menu
    }
  },
  data() {
    return {
      exporting: false
    }
  },
  methods: {
    toast,
    // accepts {data: {products, variants}}, {products, variants}, a JSON string or a Blob (any server/axios setup)
    async readExportPayload(raw) {
      let body = raw
      if (typeof Blob !== 'undefined' && body instanceof Blob) {
        body = await body.text()
      }
      if (typeof body === 'string') {
        const text = body.replace(/^\uFEFF/, '').trim()
        try {
          body = JSON.parse(text)
        } catch (e) {
          throw new Error('پاسخ سرور JSON نیست (احتمالاً نسخه قدیمی بک‌اند که format=json را نمی‌شناسد و CSV برمی‌گرداند): ' + text.slice(0, 120))
        }
      }
      let data = body && body.data && (body.data.products || body.data.variants) ? body.data : body
      if (data && data.data && (data.data.products || data.data.variants)) data = data.data
      if (!data || (!data.products && !data.variants)) {
        throw new Error('ساختار پاسخ خروجی نامعتبر است (products/variants پیدا نشد)')
      }
      const list = (value) => Array.isArray(value) ? value : (value && typeof value === 'object' ? Object.values(value) : [])
      return {
        products: list(data.products).filter(item => item && typeof item === 'object'),
        variants: list(data.variants).filter(item => item && typeof item === 'object'),
      }
    },
    async exportProducts() {
      if (this.exporting) return
      this.exporting = true
      let step = 'دریافت اطلاعات'
      try {
        const query = queryBuilder(this.$store.getters['Product/getFilters'])
        const axios = getAxiosInstance()
        const response = await axios.get(`/export-data?model_name=product&format=json&${query}`)
        step = 'خواندن پاسخ'
        const data = await this.readExportPayload(response.data)
        step = 'ساخت فایل اکسل'
        const workbook = buildProductWorkbook(XLSX, data.products, data.variants)
        const date = new Date().toISOString().slice(0, 10)
        step = 'ذخیره فایل'
        XLSX.writeFile(workbook, `products-${date}.xlsx`, {compression: true})
      } catch (error) {
        // keep the real reason visible (console + toast) instead of a generic message
        console.error('[product excel export] failed at: ' + step, error)
        const detail = (error && error.response && error.response.status ? 'HTTP ' + error.response.status + ' ' : '') + ((error && error.message) || String(error))
        this.toast('خطا در دانلود فایل', `مرحله «${step}»: ${detail}`, 'error');
      } finally {
        this.exporting = false
      }
    },
    submit() {
      if (this.dataType == 'product') {
        return this.exportProducts()
      }
      let form = {
        model_name: this.dataType,
        query: ''
      }
      if (this.dataType == 'product') {
        form.query = queryBuilder(this.$store.getters['Product/getFilters'])
      }
      this.$store.dispatch('DataExport/getData', form).then(response => {
        // ساخت BOM مجدد برای اطمینان
        const bom = '\uFEFF'; // BOM برای UTF-8

        // خواندن فایل به صورت text
        const reader = new FileReader();
        reader.onload = () => {
          // اضافه کردن BOM به متن
          const csvWithBom = bom + reader.result;

          // ساخت فایل Blob جدید با BOM
          const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);

          // ساخت لینک برای دانلود
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'export.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
        };
        reader.readAsText(response.data);
      }).catch((error) => {
        this.toast('خطا در دانلود فایل','خطا در دانلود فایل','error');
      });


    }
  }
}
</script>

<style scoped>

</style>